/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Shortcuts_SearchInputs */

const he_help_shortcuts_search = /** @type {(inputs: Help_Shortcuts_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חיפוש`)
};

const en_help_shortcuts_search = /** @type {(inputs: Help_Shortcuts_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Help_Shortcuts_SearchInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const help_shortcuts_search = /** @type {((inputs?: Help_Shortcuts_SearchInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Shortcuts_SearchInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_shortcuts_search(inputs)
	return en_help_shortcuts_search(inputs)
});